var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRestructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 18,
    viewBox: "0 0 146 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.05 15.4862L137.297 6.92978L133.763 17.923L145.05 15.4862ZM1.3804 17.4301C27.0269 8.46172 47.3156 3.38144 67.8771 2.605C88.4326 1.82878 109.33 5.35166 136.187 13.6878L136.779 11.7777C109.793 3.40127 88.6588 -0.181187 67.8016 0.606421C46.9506 1.3938 26.4448 6.5465 0.720213 15.5422L1.3804 17.4301Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRestructure);
export default __webpack_public_path__ + "static/media/arrow_restructure.95689cf363a172402055678bffc7c080.svg";
export { ForwardRef as ReactComponent };